import { theme } from 'antd'
import { observer } from 'mobx-react-lite'

import { DashboardStatTile, StatGrid } from '@/Ship/Components/Dashboard/DashboardStatTile'
import { Panel } from '@/Ship/Components/Dashboard/Overview/shared'
import { dashboardManager } from '@/Ship/Stores/DashboardManager'

/** Підписи — дослівно з легасі (`translation.json:601-603`). */
export const NO_OFFERS_TILES = {
    request: 'Запитів без пропозицій',
    tender: 'Тендери без пропозицій',
    application: 'Заявок без пропозицій',
} as const

/**
 * «Без пропозицій» (`SPEC-027` §2.4, §3.5): помаранчеві числа в одному блоці. Для запитів і
 * тендерів — «усього нових у компанії / без моєї пропозиції», для заявок —
 * лише «без моєї пропозиції». Друге число — той самий лічильник, що бейдж меню.
 *
 * Лише для глядача з правом `dashboard_no_offers` (L, SL, A); бек без права
 * віддає `null`, і блоку немає.
 */
export const TransportNoOffersTiles = observer(() => {
    const { token } = theme.useToken()
    const { transport, isTransportLoading } = dashboardManager

    if (!dashboardManager.showsNoOffers) return null

    const noOffers = transport?.noOffers

    return (
        <Panel
            block="transport-no-offers"
            title="Без пропозицій"
            subtitle="Усього нових у компанії / без вашої пропозиції"
        >
            <StatGrid columns={3}>
                <DashboardStatTile
                    tile="noOffers.request"
                    title={NO_OFFERS_TILES.request}
                    value={noOffers ? `${noOffers.requestTotal} / ${noOffers.request}` : null}
                    loading={isTransportLoading}
                    color={token.colorWarning}
                />
                <DashboardStatTile
                    tile="noOffers.tender"
                    title={NO_OFFERS_TILES.tender}
                    value={noOffers ? `${noOffers.tenderTotal} / ${noOffers.tender}` : null}
                    loading={isTransportLoading}
                    color={token.colorWarning}
                />
                <DashboardStatTile
                    tile="noOffers.application"
                    title={NO_OFFERS_TILES.application}
                    value={noOffers?.application}
                    loading={isTransportLoading}
                    color={token.colorWarning}
                />
            </StatGrid>
        </Panel>
    )
})
